import { PPConfigType } from '../typegen/pp-config-type';
import { CISConfigType } from '../typegen/cis-config-type';
import type { PPProviderBehavior, CISProviderBehavior } from './types';
import tapInsertImage from '../../assets/TapInsert.png';
import tapSwipeInsertImage from '../../assets/TapSwipeInsert.png';

import { defaultPPBehavior } from './pp/default';
import { grantStreetBehavior } from './pp/grant-street';
import { invoiceCloudV1PPBehavior } from './pp/invoicecloud-v1';
import { invoiceCloudV2PPBehavior } from './pp/invoicecloud-v2';
import { fiservBehavior } from './pp/fiserv';
import { paymentusPPBehavior } from './pp/paymentus';
import { myUsagePPBehavior } from './pp/myusage';

import { defaultCISBehavior } from './cis/default';
import { invoiceCloudCISBehavior } from './cis/invoicecloud';
import { actCISBehavior } from './cis/act';
import { csaCISBehavior } from './cis/csa';
import { paymentusCISBehavior } from './cis/paymentus';
import { conEdCISBehavior } from './cis/coned';

const ppBehaviors: Record<PPConfigType, PPProviderBehavior> = {
	[PPConfigType.None]: defaultPPBehavior,
	[PPConfigType.DynaTouch]: defaultPPBehavior,
	[PPConfigType.GrantStreet]: grantStreetBehavior,
	[PPConfigType.InvoiceCloudV1]: invoiceCloudV1PPBehavior,
	[PPConfigType.InvoiceCloudV2]: invoiceCloudV2PPBehavior,
	[PPConfigType.Fiserv]: fiservBehavior,
	[PPConfigType.Paymentus]: paymentusPPBehavior,
	[PPConfigType.PayGo]: defaultPPBehavior,
	[PPConfigType.MyUsage]: myUsagePPBehavior,
};

const cisBehaviors: Record<CISConfigType, CISProviderBehavior> = {
	[CISConfigType.None]: defaultCISBehavior,
	[CISConfigType.DynaTouch]: defaultCISBehavior,
	[CISConfigType.InvoiceCloudV1]: invoiceCloudCISBehavior,
	[CISConfigType.InvoiceCloudV2]: invoiceCloudCISBehavior,
	[CISConfigType.ACT]: actCISBehavior,
	[CISConfigType.Csa]: csaCISBehavior,
	[CISConfigType.Paymentus]: paymentusCISBehavior,
	[CISConfigType.ConEd]: conEdCISBehavior,
	[CISConfigType.PayGo]: defaultCISBehavior,
	[CISConfigType.MyUsage]: defaultCISBehavior,
};

export function getPPBehavior(type: PPConfigType): PPProviderBehavior {
	return ppBehaviors[type] ?? defaultPPBehavior;
}

export function getCISBehavior(type: CISConfigType): CISProviderBehavior {
	return cisBehaviors[type] ?? defaultCISBehavior;
}

/**
 * Card payment screen image for the kiosk's CIS: tap and insert only when its card reader has no
 * magstripe (supportsCardSwipe === false), otherwise tap, swipe and insert.
 */
export function getCardPaymentImage(type: CISConfigType): string {
	return getCISBehavior(type).supportsCardSwipe === false ? tapInsertImage : tapSwipeInsertImage;
}

export type { PPProviderBehavior, CISProviderBehavior, TestPanelConfig, PrepareTransactionContext } from './types';
